export default __webpack_public_path__ + "static/media/1.f0297600.jpg";